export default __webpack_public_path__ + "static/media/640_blank-it-mobile.2f767741.png";